<template>
  <div>
    <img src="../assets/img/404.png" alt="" class="not-found">
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  created() {
  }
}
</script>

<style scoped>
.not-found{
  position: absolute;
  width: 80%;
  top: 25%;
  left: 50%;
  transform: translateX(-40%);
}
</style>